import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  display: flex;
  align-items: stretch;
  overflow: hidden;
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;
